import { connect } from 'react-redux';
import Equivalencies from './Equivalencies';

import { getAnnualResults } from '../../selectors';


const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
});

const combinedActions = {
};

export default connect(mapStateToProps, combinedActions)(Equivalencies);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/Equivalencies/index.js